import React from "react";

const Appliances = () => {
  return <div>Appliances</div>;
};

export default Appliances;
